import * as tslib_1 from "tslib";
import { utils } from "@cloudpivot/common";
import { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, IS_FEISHU, } from "./is-platform";
import { BrowserService } from "./platform-service";
// import { DingTalkService } from './dingtalk/dingtalk-service';
import { Base64 } from "js-base64";
import { buildFeishuPostLoginUrl, getFeishuAppId, getFeishuCorpId, getFeishuPlatform } from './feishu/query';
export { getFeishuAppId, getFeishuCorpId };
function parseToken(token) {
    const useInfoBs = token.split(".")[1];
    const useInfo = JSON.parse(Base64.decode(useInfoBs));
    return useInfo;
}
export { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, };
let service = new BrowserService();
// 删除url中某个参数,并跳转
function funcUrlDel(name) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + "?";
    var query = loca.search.substr(1);
    if (query.indexOf(name) > -1) {
        var obj = {};
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split("=");
            obj[arr[i][0]] = arr[i][1];
        }
        ;
        delete obj[name];
        var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
        return url;
    }
    ;
}
// 删除url中某个参数,并跳转
function funcUrlDelFeishu() {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + "?";
    var query = loca.search.substr(1);
    var obj = {};
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
    }
    ;
    // 删除特定的几个参数，在飞书跳转的时候
    delete obj['empNo'];
    delete obj['platform']; // 手机端需要这个
    if (window.location.href.indexOf("mobile") <= -1) {
        delete obj['corpId']; // 手机端不能删除不corpId
    }
    var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&") + loca.hash;
    return url;
}
export function start(client_id, scope) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let _service = null;
        let query = utils.parseQuery();
        let urls = window.location.pathname;
        let loginInfo;
        let p = null;
        let empNoWind;
        let corpIdWind;
        if (IS_DEBUG) {
        }
        else {
            if (IS_DINGTALK && !IS_FEISHU) {
                const dingtalk = yield import(
                /* webpackChunkName: "dingtalk" */ "./dingtalk");
                p = dingtalk.init(client_id, scope, query);
                _service = new dingtalk.DingTalkService();
            }
            if (IS_WECHAT) {
                // 企业微信统一配置pc端地址，在此判断是否跳转至移动端
                if (IS_WECHAT_PC_MAC || IS_WECHAT_PC_WINDOW) {
                    const wechat = yield import(
                    /* webpackChunkName: "dingtalk" */ "./wechat");
                    p = wechat.init(client_id, scope, query);
                    _service = new wechat.WechatService();
                }
                else {
                    if (window.location.href.indexOf("mobile") <= -1) {
                        const { origin, search } = window.location;
                        const url = `${origin}/mobile${search}`;
                        window.location.href = url;
                        return;
                    }
                    else {
                        const wechat = yield import(
                        /* webpackChunkName: "dingtalk" */ "./wechat");
                        p = wechat.init(client_id, scope, query);
                        _service = new wechat.WechatService();
                    }
                }
            }
            let { empNo, corpId } = query;
            const platform = getFeishuPlatform(query);
            // 记录全局的变量用于后面判断
            corpIdWind = corpId;
            empNoWind = empNo;
            // console.log('aaa:' + JSON.stringify(platform) + JSON.stringify(empNo) + JSON.stringify(corpId) + 'isfeishu:' + IS_FEISHU + platform);
            if (IS_FEISHU || platform === 'feishu' || (empNo && corpId) || platform === 'feiShuWork') { // 桌面端无法拿到飞书的标识， 所以在桌面端入口页面中加了 feishu 的标识
                const feishu = yield import(/* webpackChunkName: "dingtalk" */ './feishu');
                p = feishu.init(client_id, scope, query);
                _service = new feishu.FeishuService();
            }
        }
        if (_service) {
            service = _service;
        }
        if (p) {
            const res = yield p;
            if (res) {
                const { access_token, userinfo, refresh_token, expiration } = res;
                loginInfo = res;
                const info = parseToken(access_token);
                if (info) {
                    const user = userinfo;
                    user.isAppAdmin = info.isAppAdmin;
                    user.isAdmin = info.isAdmin;
                }
                sessionStorage.setItem("user", JSON.stringify(userinfo));
                localStorage.setItem("token", access_token);
                localStorage.setItem("refresh_token", JSON.stringify(refresh_token));
                localStorage.setItem("expireTime", `${expiration}`);
                // alert('000');
                let url = window.location.href;
                // 过滤最终的链接
                setTimeout(function () {
                    if (corpIdWind || empNoWind) {
                        url = funcUrlDelFeishu();
                        // (window as any).location.href = url; //  去掉参数后跳转
                        history.replaceState(null, '', url); //更新链接
                    }
                    if (query.code) {
                        const endUrl = buildFeishuPostLoginUrl(url, query, window.config.appId);
                        if (endUrl) {
                            window.location.href = endUrl;
                        }
                    }
                }, 500);
            }
        }
        else {
            utils.copyURL(query, 'portal');
        }
        return {
            query,
            loginInfo,
        };
    });
}
export { service };
